/*
* アンカーリンク（ページ内）
*/
const anchorLink = function() {

	$('a[href*="#"]:not(.js-modal)').click(function(e) {
		const href = $(this).attr('href');
		const url = new URL(href, location.href);

		// 同一ページ内アンカーだけ対象にする
		if (url.pathname === location.pathname) {
			e.preventDefault();

			let $target = $(url.hash === '#' || url.hash === '' ? 'html' : url.hash);
			if (!$target[0]) $target = $('html');
			anchorScroll($target);
		}
	});

}


/*
* アンカーリンク（ページ遷移時）
*/
const anchorLinkUrlHash = function() {
	const urlHash = location.hash.replace('#', '');
	if (!urlHash) return;

	const scrollToTarget = () => {
		const $target = $('#' + urlHash);
		if ($target.length) {
			anchorScroll($target);
			history.replaceState(null, null, location.pathname);
		}
	};

	// 1回目：ロード完了時
	$(window).on('load', function() {
		scrollToTarget();
	});

	// 2回目：描画が遅れるケース（画像や動的DOM）
	setTimeout(scrollToTarget, 1000);
};





/*
* アンカー時のスクロール
*/
const anchorScroll = function(target) {

	if (!target || !target.offset()) return;

	let position = target.offset().top;
	const headerHeight = $('header').outerHeight(true);
	const speed = 500;

	// SP（スマホ）の場合、ヘッダー分の高さを引く
	if ($(window).outerWidth() <= 1024) {
		position -= headerHeight;
	}

	$('html, body').animate({scrollTop: position}, speed, 'swing', function() {
    // アニメーション完了後、位置を再計算して微調整（スムーズにアニメーション）
    setTimeout(function() {
      let newPosition = target.offset().top;
      if ($(window).outerWidth() <= 1024) {
        newPosition -= headerHeight;
      }
      const currentScroll = $(window).scrollTop();
      const diff = Math.abs(currentScroll - newPosition);

      // 差が10px以上ある場合のみ再調整（スムーズなアニメーション）
      if (diff > 10) {
        $('html, body').animate({scrollTop: newPosition}, 300, 'swing');
      }
    }, 100);
  });

	return false;
}


/*
* init
*/



/*
* on load
*/
$(window).on('load', function() {
	anchorLink();
	anchorLinkUrlHash();
});

